export default __webpack_public_path__ + "static/media/company7.d94499f7.png";